<template>
  <div v-show="show" class="candidate-select" tabindex="0">
    <div class="select-wrapper">
      <div class="selected open" :class="{ empty: !candidates.length }">
        <div class="input-wrapper">
          <input
            ref="input"
            type="text"
            :placeholder="$t('Search for name or email')"
            class="form-control bgm-white data-table-head-input f-12 m-r-30"
            :disabled="inputFieldDisabled"
            :value="searchTerm"
          />
          <span class="glyphicon glyphicon-search form-control-feedback f-14 m-r-0 p-t-0" />
        </div>
        <BaseButton v-if="showCreateButton" class="create-button" size="sm" @click="onClickCreate">
          <WdsStack align-center gap-sm>
            <i class="zmdi zmdi-plus" />
            {{ $t('Create new candidate') }}
          </WdsStack>
        </BaseButton>
      </div>
      <WdsStack v-show="loading" justify-center class="p-5">
        <ButtonSpinner />
      </WdsStack>
      <div v-if="candidates.length" class="items">
        <div
          v-for="candidate in candidates"
          :key="candidate.globalId"
          class="select-item"
          :data-test="'candidate-' + candidates.indexOf(candidate)"
          @click="onSelect(candidate)"
        >
          <WdsAvatarLabel
            :path="
              getAvatarPath(
                candidate.freelancer.hasPicture ? candidate.freelancer.picture : undefined,
                candidate.freelancer.globalId,
              )
            "
            :initials="candidate.freelancer.initials"
            :text="candidate.freelancer.name"
            :sub-text="candidate.inviteEmail"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WdsStack, WdsAvatarLabel } from '@worksome/wds-components'
import { nextTick } from 'vue'
import ButtonSpinner from '@/components/ButtonSpinner.vue'
import BaseButton from '@/components/BaseButton.vue'
import { getAvatarPath } from '@/utils/avatar'

export default {
  components: { ButtonSpinner, WdsStack, WdsAvatarLabel, BaseButton },
  props: {
    candidates: {
      type: Array,
      default: () => [],
    },
    showCreateButton: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: false,
    },
    searchTerm: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    onClickCreate: {
      type: Function,
      default: null,
    },
  },
  computed: {
    inputFieldDisabled() {
      return this.candidates.length === 0 && !this.searchTerm
    },
  },
  watch: {
    show(shouldShow) {
      if (shouldShow) {
        nextTick(() => this.$refs.input.focus())
      }
    },
  },
  methods: {
    getAvatarPath,
    onSelect(option) {
      this.$emit('addCandidate', option)
    },
  },
}
</script>

<style scoped lang="scss">
@import 'resources/sass/frontend/_color-variables';

.candidate-select {
  position: relative;
  width: 320px;
}

.candidate-select .selected {
  background-color: $white;
  padding: 12px;
}

.candidate-select .selected.open {
  border-radius: 4px 4px 0px 0px;
}

.candidate-select .selected.open.empty {
  border-radius: 4px;
}

.candidate-select .items {
  background-color: $white;
  left: 0;
  right: 0;
  z-index: 1;
  padding: 0 12px 12px 12px;
  max-height: 200px;
  overflow: auto;
  border-radius: 0px 0px 4px 4px;
}

.candidate-select .items .select-item {
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
}

.candidate-select .items .select-item:hover {
  background-color: $indigo-50;
}

.input-wrapper {
  position: relative;
  width: 100%;
}

.select-wrapper {
  @apply tw-shadow-sm;
  border-radius: 4px;
  position: absolute;
  z-index: 15;
  width: 100%;
}

.create-button {
  width: 100%;
  margin-top: 12px;

  .zmdi.zmdi-plus {
    font-size: 16px;
  }
}
</style>
